module.exports = __webpack_public_path__ + "img/7.4f54e3fe.png";